import { createContext, useContext, useMemo } from 'react';
import { CONSTANTS } from '../components/Helpers/Configuration';

const VAContext = createContext(null);

export function VirtualAdvisorProvider({
    children,
    enabled = true,
    tenantSubdomain,
    baseHost,
    categoryGroupId,
    showForUser = () => true,
    zIndex = CONSTANTS.virtualAdvisor.zIndex,
}) {
    const value = useMemo(() => {
        const resolvedTenantSubdomain = tenantSubdomain?.trim?.() || '';
        const canRender = Boolean(enabled && resolvedTenantSubdomain);

        const buildUrl = () => {
            if (!resolvedTenantSubdomain || !baseHost) {
                return '';
            }

            return `https://${resolvedTenantSubdomain}.${baseHost}/virtualadvisor/categoryGroups/${categoryGroupId}/True`;
        };

        return {
            enabled: canRender,
            showForUser,
            zIndex,
            iframeSrc: buildUrl(),
            origin: resolvedTenantSubdomain && baseHost ? `https://${resolvedTenantSubdomain}.${baseHost}` : '',
        };
    }, [enabled, showForUser, zIndex, tenantSubdomain, baseHost, categoryGroupId]);

    return <VAContext.Provider value={value}>{children}</VAContext.Provider>;
}

export function useVirtualAdvisorConfig() {
    const ctx = useContext(VAContext);

    if (!ctx) {
        throw new Error('useVirtualAdvisorConfig must be used within VirtualAdvisorProvider');
    }

    return ctx;
}

